import React from 'react';
import { Poppins } from 'src/common';
import { BaseCard } from '../../styled';
import { DashboardQuery } from 'src/graphql/_generated';
import { AssessmentState } from '../types';
import { DangerTooltip } from '../comps';
import styled from 'styled-components';

const OverdueChip = styled.div`
  display: flex;
  margin-right: auto;
  align-items: center;
  gap: 6px;
  border-radius: 2px;
  padding: 7px 8px 2px 8px;
  background-color: ${({ theme }) => theme.colors.statusRed};
  * {
    color: ${({ theme }) => theme.colors.white};
  }
`;

interface OverdueReviewsProps {
  value: DashboardQuery['dashboard']['overdueReviews'];
  state: AssessmentState;
}

export const OverdueReviews: React.FC<OverdueReviewsProps> = ({ value, state }) => {
  return (
    <BaseCard>
      <span className="c-title">Overdue Reviews</span>
      <span className="description">You should review your risk scenarios on a regular basis.</span>
      <div style={{ flex: 1 }} />

      {state === 'NO_SCENARIOS' ? (
        <DangerTooltip state={state} />
      ) : (
        <OverdueChip>
          <Poppins weight={600} color="statusRed" px={26} className="value">
            {value?.scenarios}{' '}
            <Poppins weight={500} color="statusRed" px={14}>
              overdue
            </Poppins>
          </Poppins>
        </OverdueChip>
      )}
    </BaseCard>
  );
};
